(function() { window.GUID_35caf845_0a4b_4e06_8b67_05cd54d25425 = { getGuid: function() { return "35caf845-0a4b-4e06-8b67-05cd54d25425"; } }; })();
var PersonnalSchedule;
(function (PersonnalSchedule) {
    $(function () {
        let gridViewPersonnalScheduleUI = $('#GridViewPersonnalSchedule');
        let gridViewPersonnalSchedule = gridViewPersonnalScheduleUI.data('context');
        CS.body.on('Refreshed', '#GridViewPersonnalSchedule', function (e, gridView) {
            gridViewPersonnalSchedule = gridView;
        });
        var btnPrintSchedule = $('#BtnPrintSchedule');
        btnPrintSchedule.off('click');
        document.SelectedEntityBaseId.SelectionChange = function () {
            if (this.val() != "0" && this.val() != "") {
                btnPrintSchedule.removeClass('IsDisabled');
            }
            else {
                btnPrintSchedule.addClass('IsDisabled');
            }
        };
        btnPrintSchedule.on('click', 'a', function (e) {
            var reportParam = "?ReportName=LeagueEntitySchedule" +
                "&ShowReportViewer=false" +
                "&EntityBaseId=" + document.SelectedEntityBaseId.val() +
                "&SelectedStatGroupId=null";
            this.target = "_blank";
            this.href = CSParameters.RUrl + "Printing/Print/" + CSParameters.SportEventId + reportParam;
            document.SelectedEntityBaseId.val();
        });
    });
})(PersonnalSchedule || (PersonnalSchedule = {}));

//# sourceMappingURL=PersonnalSchedule.js.map
